import register from 'ShopUiBundle/modules/app/registry';
import '../header-mobile-menu-item';
import '../basic-modal';
import './style.scss';

// tslint:disable-next-line
register('header-mobile-menu', () => import(/* webpackMode: "lazy" */'./header-mobile-menu'));
